import {Component, store, constant} from 'Generic';
import {DEDICATED_IP_ICON, addonIconMap} from 'Generic/constants/addonIcons';
import {
  numberFormat,
  getTranslation,
  addCurrencySymbol,
  calculatePowerPackDiscountedPrice,
  calculatePowerPackMonthlyOldPrice,
  calculateDiscountedAmountAndPercentage,
} from 'Generic/lib';

export default class VpnAddons extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.pro-pure-vpn-addons'),
      state: store.state,
    });
  }

  render() {
    const elementOne = document.querySelector('.pure-pure-box-v1');
    const elementTwo = document.querySelector('.pure-pure-box-v2');

    const {
      vpnAddonsList,
      DEDICATED_IP,
      PORT_FORWARDING,
      DEDICATED_SERVER,
      MULTI_LOGIN,
      PORT_FORWARDING_DEDICATED_IP,
      RESIDENTIAL_NETWORK_BANDWIDTH,
      excludeAddonsOnTrial,
      addonWithExtraMonth,
    } = constant;

    let addonsOneHtml = '';
    let addonsTwoHtml = '';

    const addonsToBeDisplay = [...vpnAddonsList, RESIDENTIAL_NETWORK_BANDWIDTH];

    // Getting Selected Plan Details
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const planType = JSON.parse(selectedPlan?.description || '{}')?.plan_type || 'vpn_standard';

    // Addon specific order
    const addonListOrder = {
      [DEDICATED_IP]: 1,
      [PORT_FORWARDING]: 2,
      [RESIDENTIAL_NETWORK_BANDWIDTH]: 3,
      [DEDICATED_SERVER]: 4,
      [MULTI_LOGIN]: 5,
    };

    const addonList = (selectedPlan?.addons || [])
      .filter(item => addonsToBeDisplay.includes(item.code))
      .sort((a, b) => {
        const orderA = addonListOrder[a.code] || 0;
        const orderB = addonListOrder[b.code] || 0;
        return orderA - orderB;
      })
      .map(item => {
        if (item.code === DEDICATED_IP || item.code === PORT_FORWARDING) {
          return {
            ...item,
            isFirstPart: true,
          };
        }
        return item;
      });

    const powerPackAddon = (selectedPlan?.addons || []).find(item => item.code === PORT_FORWARDING_DEDICATED_IP);
    const powerPackAddonPrice = powerPackAddon?.unit_amount
      ? Number(powerPackAddon.unit_amount) / Number(selectedPlan.months || selectedPlan.interval_length)
      : 0;

    // Getting Addons Details
    const selectedAddons = this.state.selected_addons || [];
    const disabledAddons = this.state.disable_addons || [];
    let discountedPowerPackTotal = calculatePowerPackDiscountedPrice();
    let powerPackMonthlyOldPrice = calculatePowerPackMonthlyOldPrice();
    const trialLength = Number(selectedPlan?.trial_length || 0);
    const currencyCode = this.state.currency_code;
    const oldPrices = this.state.old_prices;

    const oldAddonPrices = oldPrices[currencyCode] || {};

    const priceOldAddon = oldAddonPrices[PORT_FORWARDING_DEDICATED_IP] ? Number(oldAddonPrices[PORT_FORWARDING_DEDICATED_IP]) : 0;

    // Targetting HTML Elements
    const oldAddonPriceWrapper = document.querySelector('.pro-pure-vpn-wrapper.pro-vpn-addons #combo-old-price');
    const newAddonPriceWrapper = document.querySelector('.pro-pure-vpn-wrapper.pro-vpn-addons #combo-new-price');
    const discountPercentage = document.querySelector('#powerpack-discount');
    const specialDiscountText = document.querySelector('#powerpack-splabel');

    const comboPrice = document.querySelector('.combo-price p');

    if (powerPackAddonPrice) {
      comboPrice.innerHTML = `
        ${addCurrencySymbol(numberFormat(powerPackAddonPrice))}<span>/${getTranslation('mo')}</span>`;
    }

    const comboCutPrice = priceOldAddon > powerPackAddonPrice ? priceOldAddon : '';
    const comboCutPriceHTML = document.querySelector('.combo-cut-price');

    comboCutPriceHTML.innerHTML = comboCutPrice ? `${addCurrencySymbol(numberFormat(comboCutPrice))}` : '';

    const comboDiscountBox = document.querySelector('.combo-discount-box');
    const comboPriceBox = document.querySelector('.combo-price-box');

    if (comboDiscountBox && priceOldAddon > powerPackAddonPrice) {
      comboDiscountBox.innerHTML = `
      <span class="pvpn-saving-label">
        ${getTranslation('addon_saving_label')} ${Math.round((1 - powerPackAddonPrice / priceOldAddon) * 100)}%
      </span>`;
    } else {
      comboDiscountBox.innerHTML = '';
      comboPriceBox.classList.add('no-discount');
    }

    if (oldAddonPriceWrapper && newAddonPriceWrapper) {
      // Updating Total Price
      discountedPowerPackTotal = Number(discountedPowerPackTotal) / Number(selectedPlan.months || selectedPlan.interval_length);
      newAddonPriceWrapper.value = numberFormat(discountedPowerPackTotal);

      if (powerPackMonthlyOldPrice > discountedPowerPackTotal) {
        const [powerPackDiscount] = calculateDiscountedAmountAndPercentage(Number(powerPackMonthlyOldPrice), discountedPowerPackTotal);

        // Updating Cut price & Percentagae
        if (discountPercentage) {
          discountPercentage.childNodes[0].textContent = `${powerPackDiscount}%`;
        }

        oldAddonPriceWrapper.value = numberFormat(powerPackMonthlyOldPrice);

        specialDiscountText.classList.add('active');
      } else {
        // Hiding cut Price & Percentage
        specialDiscountText.classList.remove('active');
      }
    }

    // Getting Addon Strip HTML
    const full_suit = document.querySelector('#pro-fsuite-vpn-addons');
    full_suit.classList.add('show');

    // Array to store addons that need to be checked when adding PowerPack
    let addonsToBeChecked = [];
    if (selectedAddons.includes(constant.powerPackAddon)) {
      addonsToBeChecked.push('dedicated_ip', 'port_forwarding');
    }

    // Check if there are addons in the list
    if (addonList?.length) {
      for (const addon of addonList) {
        const addonTitle = getTranslation(addon.code);
        const priceOldAddon = oldAddonPrices[addon?.code] ? Number(oldAddonPrices[addon?.code]) : 0;
        const powerPackCond = selectedAddons.includes(addon.code) || addonsToBeChecked.includes(addon.code);

        // Calculate the addon price based on the unit amount and selected plan interval length
        const effectiveMonths = addonWithExtraMonth.includes(addon.code) ? selectedPlan.months : selectedPlan.interval_length;
        const addonPrice = addon?.unit_amount ? Number(addon.unit_amount) / Number(effectiveMonths) : 0;
        const isDiscounted = priceOldAddon > addonPrice;
        let addonsHtml = '';

        // For Trials remove Dedicated Server and Residential Network Addon
        const trialCondition = excludeAddonsOnTrial.includes(addon?.code) && trialLength > 0;
        if (trialCondition) {
          elementTwo?.classList.add('one-box');
          continue;
        }

        if (addon.state === 'active') {
          addonsHtml += `
          <div id="addon_box_click_${
            addon.code
          }"  data-eventname="cro_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_stripe_box_click|${
            addon.code
          }" class="addon-btn special-addon-box vpn-addon-box ${
            selectedAddons.includes(addon.code) || selectedAddons.includes(`${addon.code}_discounted`) ? 'active' : ''
          } ${disabledAddons.includes(addon.code) ? 'disabled' : ''}" addon-code="${addon.code}">

            <div class="p-vpn-top-sec">
              <div class="p-vpn-hdg">
                <div class="p-vpn-hdg-top">
                  ${addonIconMap[addon?.code] || DEDICATED_IP_ICON}
                  <span class="heading-box">
                    <h3>${addonTitle}</h3>
                    <i  data-eventname="cro_info_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_stripe|${
                      addon.code
                    }" class="popup_link" addon-code="${addon.code}">
                      <svg id="popup-${
                        addon.code
                      }" class="icon-helper" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M6.1002 9.59377C6.26946 9.59377 6.41144 9.53642 6.52614 9.42172C6.64084 9.30702 6.69799 9.16524 6.69759 8.99638V6.60679C6.69759 6.43752 6.64024 6.29554 6.52554 6.18084C6.41084 6.06614 6.26906 6.00899 6.1002 6.00939C5.93093 6.00939 5.78895 6.06674 5.67425 6.18144C5.55955 6.29614 5.5024 6.43792 5.5028 6.60679V8.99638C5.5028 9.16564 5.56015 9.30762 5.67485 9.42232C5.78955 9.53702 5.93133 9.59417 6.1002 9.59377ZM6.1002 4.8146C6.26946 4.8146 6.41144 4.75724 6.52614 4.64254C6.64084 4.52784 6.69799 4.38606 6.69759 4.2172C6.69759 4.04794 6.64024 3.90595 6.52554 3.79125C6.41084 3.67655 6.26906 3.6194 6.1002 3.6198C5.93093 3.6198 5.78895 3.67715 5.67425 3.79185C5.55955 3.90655 5.5024 4.04833 5.5028 4.2172C5.5028 4.38646 5.56015 4.52844 5.67485 4.64314C5.78955 4.75784 5.93133 4.81499 6.1002 4.8146ZM6.1002 12.5808C5.2738 12.5808 4.49718 12.4238 3.77035 12.11C3.04351 11.7962 2.41127 11.3706 1.87361 10.8334C1.33595 10.2957 0.910405 9.66347 0.59697 8.93664C0.283535 8.2098 0.126619 7.43319 0.126221 6.60679C0.126221 5.78039 0.283137 5.00377 0.59697 4.27694C0.910803 3.5501 1.33635 2.91786 1.87361 2.3802C2.41127 1.84254 3.04351 1.417 3.77035 1.10356C4.49718 0.790127 5.2738 0.633211 6.1002 0.632812C6.9266 0.632812 7.70321 0.789729 8.43005 1.10356C9.15688 1.41739 9.78913 1.84294 10.3268 2.3802C10.8644 2.91786 11.2902 3.5501 11.604 4.27694C11.9179 5.00377 12.0746 5.78039 12.0742 6.60679C12.0742 7.43319 11.9173 8.2098 11.6034 8.93664C11.2896 9.66347 10.864 10.2957 10.3268 10.8334C9.78913 11.371 9.15688 11.7968 8.43005 12.1106C7.70321 12.4244 6.9266 12.5812 6.1002 12.5808Z" fill="#949C9E"/>
                      </svg>
                    </i>
                  </span>
                </div>
                <span class="p-vpn-hdg-sub">${getTranslation(`${addon.code}_addon_sub_hdg`)}</span>
              </div>
            </div>
            
              <div class="pvpn-price-checkbox-box">
                <div class="pvpn-price-box">
                ${
                  isDiscounted
                    ? `
                  <span class="pvpn-cut-price">
                    ${addCurrencySymbol(numberFormat(priceOldAddon))} 
                  </span>
                  
                  <span class="pvpn-saving-label">
                    ${getTranslation('addon_saving_label')} ${Math.round((1 - addonPrice / priceOldAddon) * 100)}%
                  </span>`
                    : ''
                }
                  <p>
                    ${addCurrencySymbol(numberFormat(addonPrice))}
                    <span>/${getTranslation('mo')}</span>
                  </p>
                </div>

            <div id="addon_cta_${
              addon.code
            }" data-eventname="cro_addon_click"  data-eventparamkey="position|element_text"  data-eventparamvalue="addon_stripe_cta|${
            addon.code
          }" class="pvpn-checkbox ${powerPackCond ? 'active' : ''}">
               <div class="vpn-addon-button-label">
                  <button type="button"  id="${addon.code}" class="vpn-addon-btn ${powerPackCond ? 'icon-check' : 'icon-plus'}"></button>
                </div>
                <div class="vpn-addon-text ${powerPackCond ? 'vpn-addon-added' : 'vpn-addon-add'}">${powerPackCond ? 'Added' : 'Add'}</div>  
            </div>
            </div>
          </div>
        `;
        }

        if (addon?.isFirstPart) {
          addonsOneHtml += addonsHtml;
        } else {
          addonsTwoHtml += addonsHtml;
        }
      }
    }

    //Disabling PowerPack Btn when both indivisual addons are added
    const powerPackBtn = document.querySelector('#powerpack-btn');
    if (selectedAddons.includes('dedicated_ip') && selectedAddons.includes('port_forwarding')) {
      powerPackBtn?.classList.add('disabled');
    } else {
      powerPackBtn?.classList.remove('disabled');
    }

    //Activating PowerPack Strip Class
    const vpnAddonsStrip = document.querySelector('.pro-pure-vpn-addons');
    if (vpnAddonsStrip) {
      if (selectedAddons.includes(constant.powerPackAddon)) {
        vpnAddonsStrip.classList.add('active');
      } else {
        vpnAddonsStrip.classList.remove('active');
      }
    }

    /* Removing special addon boxes before appending new addon boxes */
    const addonBoxes = this.element.querySelectorAll('.special-addon-box') || [];
    addonBoxes.forEach(box => {
      box.remove();
    });

    elementOne.innerHTML = addonsOneHtml;
    elementTwo.innerHTML = addonsTwoHtml;
  }
}
